import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { routes } from "pages/routes";
import Button from "components/ui/Button";
import logoImg from "images/talaera-logo-white.svg";

import styles from "./PasswordResetDone.module.scss";

export default function PasswordResetDone() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navigateToSignIn = () => {
    navigate(routes.public.signIn.path());
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <a className={styles.logo} href="//talaera.com">
          <img src={logoImg} alt="Talaera" />
        </a>
        <h1 className={styles.title}>{t("Auth.resetDone.headline")}</h1>
        <p className={styles.body}>{t("Auth.resetDone.message")}</p>
        <div className={styles.actions}>
          <Button onClick={navigateToSignIn}>{t("Auth.nav.signIn")}</Button>
        </div>
      </div>
    </div>
  );
}
